import api from "../../config/client.axios.api";

export const updateStoreApi = async (infoUpdate: any) => {
  const response = await api.put(`/store`, infoUpdate);
  return response.data;
};
